<template>
  <div>Page Not Found</div>
</template>

<script>
export default {
  name: "PageNotFound",
  created: function () {
    if (process.env.NODE_ENV === "production") {
      window.location.href = "/404.html";
    }
  },
};
</script>

<style scoped />
